import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import BetalingModal from "./BetalingModal";
import { useEffect } from "react";
import moment from "moment";
import "moment/locale/nl";

const BoekingsregelsTabel = ({ boekingsregels, betalingen }) => {
  const [selectedBetaling, setSelectedBetaling] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [betaling, setBetaling] = useState(null);
  useEffect(() => {
    if (boekingsregels && boekingsregels.length > 0) {
      const betalingIds = boekingsregels.map((regel) => regel.betaling).filter(Boolean);
      const uniqueBetalingIds = [...new Set(betalingIds)];
      const betalingenData = uniqueBetalingIds.map((id) => betalingen.find((b) => b.id === id));
      setBetaling(betalingenData);
    }
  }, [boekingsregels, betalingen]);

  const openModal = (betalingId) => {
    const betaling = betalingen.find((b) => b.id === betalingId);
    if (betaling) {
      setSelectedBetaling(betaling);
      setModalVisible(true);
    }
  };

  const isbetaald = (regel) => {
    // Check direct betaald veld eerst (Tommy webhook boekingsregels)
    if (regel.betaald === true) {
      return true;
    }
    
    // Check traditional betaling systeem
    if (regel.betaling) {
      const betaling = betalingen.find((b) => b.id === regel.betaling);
      return betaling ? betaling.status === "paid" : false;
    }
    
    return false;
  };
  return (
    <div className="container my-4">
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th className="d-none d-md-table-cell">#</th>
              <th>Product</th>
              <th className="d-none d-sm-table-cell">Waarde</th>
              <th>Prijs</th>
              <th className="d-none d-md-table-cell">Door</th>
              <th className="d-none d-lg-table-cell">Datum</th>
              <th>Betaald</th>
              <th className="d-none d-lg-table-cell">Betaling</th>
            </tr>
          </thead>
          <tbody>
            {boekingsregels.map((regel, index) => (
              <tr key={index}>
                <td className="d-none d-md-table-cell">{index + 1}</td>
                <td>
                  <div className="d-block d-sm-none text-muted small">#{index + 1}</div>
                  {regel.product}
                  <div className="d-block d-sm-none">
                    <small className="text-muted">Waarde: {regel.value}</small>
                  </div>
                  <div className="d-block d-md-none">
                    <small className="text-muted">Door: {regel.door}</small>
                  </div>
                  <div className="d-block d-lg-none">
                    <small className="text-muted">
                      Datum: {regel.datum ? moment(regel.datum).locale('nl').format('DD-MM-YYYY HH:mm') : '-'}
                    </small>
                  </div>
                </td>
                <td className="d-none d-sm-table-cell">{regel.value}</td>
                <td>€ {parseFloat(regel.prijs).toFixed(2)}</td>
                <td className="d-none d-md-table-cell">{regel.door}</td>
                <td className="d-none d-lg-table-cell">
                  {regel.datum ? moment(regel.datum).locale('nl').format('DD-MM-YYYY HH:mm') : '-'}
                </td>
                <td>
                  {isbetaald(regel) ? (
                    <div>
                      <span className="badge bg-success">Ja</span>
                      {regel.betaalProvider && (
                        <div>
                          <small className="text-muted">via {regel.betaalProvider}</small>
                        </div>
                      )}
                      {regel.betaaldOp && (
                        <div>
                          <small className="text-muted">
                            {new Date(regel.betaaldOp).toLocaleDateString('nl-NL')}
                          </small>
                        </div>
                      )}
                    </div>
                  ) : (
                    <span className="badge bg-danger">Nee</span>
                  )}
                </td>
                <td className="d-none d-lg-table-cell">
                  {regel.betaling ? (
                    <button className="btn btn-link p-0" onClick={() => openModal(regel.betaling)}>
                      {regel.betaling}
                    </button>
                  ) : regel.transactionId ? (
                    <div>
                      <small className="text-muted">
                        {regel.betaalProvider || 'paynl'}: {regel.transactionId}
                      </small>
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <BetalingModal visible={modalVisible} onClose={() => setModalVisible(false)} betaling={selectedBetaling} />
    </div>
  );
};

export default BoekingsregelsTabel;
